<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Translation Integration</h1>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-header">
    <div class="row">
      <div class="col-3">
        <input [(ngModel)]="searchDomain" class="form-control" placeholder="Domain search..." type="text"/>
      </div>

      <div class="col">
        <select [(ngModel)]="domainId" class="form-control">
          <option [ngValue]="null">Choose a domain</option>
          @for (domain of domains; track domain) {
            @if (filterSearch(domain)) {
              <option [ngValue]="domain.id">
                #{{domain.id}} - {{ domain.description }} ({{ domain.domain }})
              </option>
            }
          }
        </select>
      </div>

      <div class="col-3">
        <app-input-switch [(ngModel)]="force" offLabel="Insert only" onLabel="Force update"></app-input-switch>
      </div>

      <div class="col text-end">
        <div (click)="openKnowledgeModal()" class="btn btn-info text-light"><i class="bi bi-bookmark-fill me-2"></i>Knowledge</div>
      </div>
    </div>
  </div>

  <div class="card-body">
    @for (translation of data; track translation; let i = $index) {
      <div class="row mt-2">
        <div class="col-auto">
          <i (click)="duplicateIncrement(i)" title="Duplicate and increment" class="bi bi-plus-circle-fill fs-4 text-secondary" role="button"></i>
        </div>
        <div class="col-4">
          <input [(ngModel)]="translation.key" (focus)="addElement()" placeholder="Key" class="form-control"/>
        </div>
        <div class="col">
          <textarea [(ngModel)]="translation.text" (focus)="addElement()" placeholder="Text" class="form-control" rows="1"></textarea>
        </div>
        <div class="col-auto">
          <i (click)="removeElement(i)" title="Remove" class="bi bi-trash-fill fs-4 text-danger" role="button"></i>
        </div>
      </div>
    }

    <div class="row mt-4">
      <div class="col-auto">
        <button (click)="addElement(true)" [disabled]="submitting" class="btn btn-secondary">
          <i class="bi bi-plus me-2"></i>Add translation
        </button>
      </div>

      <div class="col-auto">
        <button (click)="generateZodiac()" [disabled]="submitting" class="btn btn-secondary">
          Generate Zodiac
        </button>
      </div>

      <div class="col-auto">
        <button (click)="openImportModal()" [disabled]="submitting" class="btn btn-secondary">
          Import
        </button>
      </div>

      <div class="col">
        <app-input-switch [(ngModel)]="cleanUpAfterSubmit">Clean after submit</app-input-switch>
      </div>

      <div class="col">
        <button (click)="onSubmit()" [disabled]="!domainId || isEmptyData() || submitting" class="btn btn-primary">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>
